import type { ReactNode } from 'react';
import { Switch } from '@/shared/ui/switch';
import { cn } from '@/shared/lib/cn';
import type { BenefitLineDef } from '../model/operator-rules';

interface OperatorBenefitRowProps {
  line: BenefitLineDef;
  enabled: boolean;
  onToggle: (on: boolean) => void;
  detail?: ReactNode;
}

export function OperatorBenefitRow({ line, enabled, onToggle, detail }: OperatorBenefitRowProps) {
  const disabled = !line.eligible;

  return (
    <div
      className={cn(
        'glass-thin rounded-xl px-3 py-3 transition-opacity',
        disabled && 'opacity-60',
      )}
    >
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium leading-snug">{line.label}</p>
          {!disabled && line.hint ? (
            <p className="mt-0.5 text-xs text-muted-foreground">{line.hint}</p>
          ) : null}
          {disabled && line.reason ? (
            <p className="mt-0.5 text-xs text-muted-foreground">{line.reason}</p>
          ) : null}
          {!disabled && enabled && detail ? <div className="mt-2">{detail}</div> : null}
        </div>
        <Switch
          checked={enabled && !disabled}
          disabled={disabled}
          onCheckedChange={onToggle}
          className="mt-1 shrink-0"
          aria-label={line.label}
        />
      </div>
    </div>
  );
}
